import { useMemo } from "react";
import { useIntl } from "react-intl";

export const useOrder = (order) =>{
    let orderItem = order;
    const Intl = useIntl();

    const getPayUrl = useMemo(() =>{
        return orderItem.mercadopagoPayURL || orderItem.boletoPayCodeURL || orderItem.payCodeUrl;
    }, [orderItem]);

    const orderOffset = useMemo(() =>{
        if(orderItem?.expiredPaymentTime){
            return orderItem.expiredPaymentTime - orderItem?.serverTime;
        }
    }, [orderItem]);

    const getBtnText = useMemo(() =>{
        switch(orderItem?.payMethod){
            case '20':
            case '21':
            case '27':
            case '28':
            case '30':
            case '31':
            case '34':
            case '35':
            case '37':
            case '38':
            case '40':
            case '41':
            case '43':
            case '44':
            case '129':	
            case '130':
                return 'Generar Ticket'
            case '29':
                return 'Gerar Ticket'
            case '16':
            case '23':
            case '25':
                return 'Imprimir boleto'
            default:
                return Intl.formatMessage({ id: "pay_now", defaultMessage: "PAY NOW" })
        }
    }, [orderItem]);

    const getBtnText2 = useMemo(() =>{
        switch(orderItem.payMethod){
            case '20':
            case '21':
            case '27':
            case '28':
            case '30':
            case '31':
            case '34':
            case '35':
            case '37':
            case '38':
            case '40':
            case '41':
            case '43':
            case '44':
            case '129':	
            case '130':
                return 'Otro método de pago'
            case '16':
            case '23':
            case '25':
            case '29':
                return 'Outro método de pagamento'
            default:
                return null
        }
    }, [orderItem]);

    return {
        getPayUrl, 
        orderOffset, 
        getBtnText, 
        getBtnText2
    }
}